import React, { useState } from 'react'
import ReactMultiSelect from '@kenshooui/react-multi-select'
import { isEmpty } from 'lodash'
import { Autocomplete } from '@material-ui/lab'
import { Box, FormControl, TextField } from '@material-ui/core'

import { BaseDialog, Label, MultiSelectItem } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'
import useFetch from 'hooks/useFetch'

import * as service from 'service'
import useStyles from './styles'
import theme from 'theme'

const TreatmentCreationModal = ({
  open,
  setOpen,
  departments = [],
  refresh,
}) => {
  const [loading, setLoading] = useState(false)
  const [selectedDepartments, setSelectedDepartments] = useState([])
  const [selectedProcesses, setSelectedProcesses] = useState([])

  const classes = useStyles()
  const snackbar = useSnackbar()

  const { dataMultiOptions } = helpers.fragilityEntities

  const hasDepartments = !isEmpty(selectedDepartments)

  const { response, isLoading } = useFetch(
    service.dponet.dataProcesses.get,
    {
      departmentId: selectedDepartments?.map((dept) => dept.id),
      perPage: 9999,
      minimal: true,
      isFragilityList: true,
    },
    [selectedDepartments],
    hasDepartments,
  )

  const dataProcess = hasDepartments
    ? dataMultiOptions(response?.data?.dataProcesses) || []
    : []

  const disableSubmit = !hasDepartments || isEmpty(selectedProcesses)

  const messagesMultiSelect =
    helpers.dataCollected.messagesMultiSelect(isLoading)

  const { allSelectedByGroup, someSelectedByGroup } =
    helpers.validates.multiSelect
  const { filterFunction, toggleSelectByGroup } = helpers.multiSelect

  const handleChangeProcesses = (selected) => {
    if (Array.isArray(selected)) setSelectedProcesses(selected)
  }

  const allProcessesSelectedByGroup = (group) =>
    allSelectedByGroup(selectedProcesses, dataProcess, group)

  const someProcessesSelectedByGroup = (group) =>
    someSelectedByGroup(selectedProcesses, dataProcess, group)

  const selectAllByGroup = (group) =>
    setSelectedProcesses(
      toggleSelectByGroup(selectedProcesses, dataProcess, group),
    )

  const handleChangeDepartments = (_, value) => {
    const activeDepartmentNames = value.map((dept) => dept.name)
    setSelectedProcesses((prev) =>
      prev.filter((process) => activeDepartmentNames.includes(process.group)),
    )
    setSelectedDepartments(value)
  }

  const handleCloseDialog = () => setOpen(false)

  const onSubmit = async (event) => {
    event.preventDefault()
    try {
      setLoading(true)

      await service.dponet.dataProcessTreatment.batchCreate({
        dataProcessIds: selectedProcesses.map((process) => process.id),
      })

      snackbar.open({
        message: 'Tratamentos criados com sucesso!',
        variant: 'success',
      })
      refresh()
      handleCloseDialog()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error, true),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Adicionar novos tratamentos de processos"
      formRef="treatment-creation-modal-form"
      dialogSize="lg"
      fullWidth
      loading={loading}
      closeButtonText="Cancelar"
      actionButtonText="Criar"
      disableButton={disableSubmit}
    >
      <Box
        component="form"
        id="treatment-creation-modal-form"
        onSubmit={onSubmit}
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
      >
        <Label
          title="Departamentos *"
          description="Selecione os departamentos para buscar os processos"
          item
          xs={12}
        >
          <Autocomplete
            options={departments}
            value={selectedDepartments}
            getOptionLabel={(option) => option?.name || ''}
            getOptionSelected={(option, value) =>
              !value || option?.id === value?.id || value?.id === 0
            }
            onChange={handleChangeDepartments}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" fullWidth />
            )}
            multiple
          />
        </Label>
        <Label
          title="Processos *"
          description="Escolha os processos que deseja tratar"
          item
          xs={12}
        >
          <FormControl fullWidth>
            <ReactMultiSelect
              messages={messagesMultiSelect}
              items={dataProcess}
              withGrouping
              selectedItems={selectedProcesses}
              filterFunction={filterFunction}
              wrapperClassName={classes.multiSelect}
              onChange={handleChangeProcesses}
              disabled={isLoading}
              itemRenderer={(data) => (
                <MultiSelectItem
                  selectAllByGroup={selectAllByGroup}
                  allSelectedByGroup={allProcessesSelectedByGroup}
                  someSelectedByGroup={someProcessesSelectedByGroup}
                  {...data}
                />
              )}
            />
          </FormControl>
        </Label>
      </Box>
    </BaseDialog>
  )
}

export default TreatmentCreationModal
